var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendPlaneLine = function SvgSendPlaneLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.43 9.633c-.458-.185-.453-.459.031-.62L20.64 3.287c.476-.158.748.108.615.574L16.346 21.04c-.135.476-.428.497-.646.063L11.6 12.9zm4.402-.18 5.072 2.03 2.736 5.473 3.191-11.169-11 3.666Z"
  })));
};
export default SvgSendPlaneLine;